<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯云X DeepSeek：API调用+联网搜索，分钟打造企业级 AI 应用</div>
      <div class="news-date">2025年2月8日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/ai_logo.gif"/>
          </div>
        </div>
        <p>
          刚刚，腾讯云再放大招——
        </p>
        <p>
          不仅上线了
          <span class="mark-text highlight">DeepSeek-R1</span>
          和
          <span class="mark-text highlight">V3原版模型</span>
          的API接口，还将它们接入了大模型知识引擎，并
          <span class="mark-text highlight">支持联网搜索</span>
          ，成为国内率先实现这一能力的云厂商。
        </p>
        <p>
          现在只需拖拽几步，就能搭建一个基于DeepSeek、集
          <span class="mark-text highlight">「智能问答+知识管理+实时搜索」</span>
          于一体的AI应用，让大模型更智能、更精准。
        </p>
        <p>这样的新组合，将如何升级大模型使用体验？来一探究竟：</p>
        <p>
          <span class="mark-text highlight">免部署，分钟级搭建AI应用</span>
        </p>
        <p>
          在<span class="mark-text highlight">腾讯云大模型知识引擎</span>中，将DeepSeek大模型无缝整合到自己的应用场景中——
        </p>
        <p>平台提供多轮对话、文档解析、文本拆分、embedding计算等功能，开发者可以根据需求自由组合，分钟级灵活搭建智能客服、在线搜索、AI写作助手等大模型应用。</p>
        <p>比如，可基于DeepSeek搭建智能问答，支持精准对话和上下文理解，提升交互体验；还可以通过文档解析和embedding计算，实现高效的文本搜索与信息抽取……</p>
        <p>开发者还可以通过简单拖拽，实现免部署、低代码的大模型能力落地。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news68.webp"/>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">集成私域知识库，让AI更专业</span>
        </p>
        <p>想要深度定制？没问题——</p>
        <p>腾讯云大模型知识引擎支持将私域文档或数据库<span style="color: #b8b8b8">（如公司资料、产品手册、客服FAQ、法律法规等）</span>接入，再搭配RAG<span style="color: #b8b8b8">（检索增强生成）</span>能力，让DeepSeek在已有知识库的基础上做出更精准、更专业的回答。</p>
        <p>比如，让AI基于产品手册、用户FAQ，提供更加精准、高效的客户咨询服务；或者将企业文档、培训资料等整合至知识库，完成智能检索与辅助决策，实现更好的内部知识管理……</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news68/news68_1.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">支持联网搜索，实时获取信息</span>
        </p>
        <p>过去，大模型的通病是「训练时间点」与「新信息」脱节——</p>
        <p>腾讯云大模型知识引擎率先支持联网搜索，接通搜狗提供的搜索增强API，让DeepSeek可以实时抓取互联网最新资讯，提升时效性和回答准确度。</p>
        <p>这一能力适用于：</p>
        <p>● 行业热点追踪：分析金融、科技、市场趋势等最新动态，提供实时洞察；</p>
        <p>● 时效性问答：如新闻解读、政策更新等，确保信息最新最全；</p>
        <p>● 精准搜索：结合内部知识库+联网搜索，提供更全面的信息整合方案</p>
        <p>……</p>
        <p>从过去的「静态记忆」到如今的「实时学习」，大模型具备更强的信息获取与处理能力，拓展了AI在商业决策、市场调研等领域的应用空间。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news68/news68_2.webp"/>
          </div>
        </div>
        <p>当然，如果你只想快速接入大模型，腾讯云也提供了DeepSeek-R1、V3原版模型的API接口。</p>
        <p>开发者可以把DeepSeek「嵌」入网站、小程序或企业系统，无需操心算力、部署、并发等难题，只管在前端或服务端调用。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news68/news68_3.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">多种接入方式，满足不同开发需求</span>
        </p>
        <p>目前，腾讯云已提供Cloud Studio、云原生构建、HAI、TI平台、API接口、知识引擎等多种接入方式，满足不同开发需求。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news68/news68_4.webp"/>
          </div>
        </div>
        <p>现在，开发者可以通过腾讯云随心所欲地「召唤」DeepSeek。如果给你这三个基于腾讯云+DeepSeek的能力，你最想做点什么呢？</p>
        <p>❶ 低代码免部署分钟级构建AI应用</p>
        <p>❷ 融合企业知识库</p>
        <p>❸ 实时获取全网信息</p>
        <p>
          点击跳转<a href="https://cloud.tencent.com/document/product/1759/116005">DeepSeek应用创建指南</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News68.vue